import Content from "./Content";
import Header from "./Header";

const Attestation = () => {
  return (
    <div>
      <Header />
      <Content />
    </div>
  );
};

export default Attestation;
